// src/sectors/pilates/members/components/paymentReceive/PaymentChoiceStep.jsx
import React from 'react';
import Icon from '@mui/material/Icon';
import Chip from '@mui/material/Chip';
import { alpha } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

export function PaymentChoiceStep({
  styles,
  planCount,
  sessionCount,
  onGoPlan,
  onGoSession,
  onGoDebtReduce,
  onGoOther,
  onCancel,
}) {
  const { orange, cardSx, iconBadgeSx, chipSx } = styles;

  return (
    <>
      <MDBox sx={{ display: 'grid', gap: 1.25 }}>
        {/* Paket */}
        <MDBox sx={cardSx} onClick={onGoPlan}>
          <MDBox display="flex" alignItems="center" gap={1.25} minWidth={0}>
            <MDBox sx={iconBadgeSx}>
              <Icon sx={{ color: alpha(orange, 0.95) }}>inventory_2</Icon>
            </MDBox>
            <MDBox minWidth={0}>
              <MDTypography fontWeight="bold">Paket Ödemesi</MDTypography>
              <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                Aktif paket seç • Paket borcu / paket tahsilatı
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox display="flex" alignItems="center" gap={1}>
            <Chip size="small" label={`${planCount} paket`} sx={chipSx} />
            <MDButton variant="contained" color="warning" sx={{ borderRadius: '12px' }}>
              Seç
            </MDButton>
          </MDBox>
        </MDBox>

        {/* Seans */}
        <MDBox sx={cardSx} onClick={onGoSession}>
          <MDBox display="flex" alignItems="center" gap={1.25} minWidth={0}>
            <MDBox sx={iconBadgeSx}>
              <Icon sx={{ color: alpha(orange, 0.95) }}>event_available</Icon>
            </MDBox>
            <MDBox minWidth={0}>
              <MDTypography fontWeight="bold">Seans Ödemesi</MDTypography>
              <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                Seans seç • Tek seans / ders tahsilatı
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox display="flex" alignItems="center" gap={1}>
            <Chip size="small" label={`${sessionCount} seans`} sx={chipSx} />
            <MDButton variant="contained" color="warning" sx={{ borderRadius: '12px' }}>
              Seç
            </MDButton>
          </MDBox>
        </MDBox>

        {/* Diğer */}
        <MDBox sx={cardSx} onClick={onGoDebtReduce}>
          <MDBox display="flex" alignItems="center" gap={1.25} minWidth={0}>
            <MDBox sx={iconBadgeSx}>
              <Icon sx={{ color: alpha(orange, 0.95) }}>remove_circle_outline</Icon>
            </MDBox>
            <MDBox minWidth={0}>
              <MDTypography fontWeight="bold">Borç Azalt</MDTypography>
              <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                Manuel düzeltme • Sadece borç tutarı düş
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDButton variant="outlined" color="warning" sx={{ borderRadius: '12px' }}>
            Seç
          </MDButton>
        </MDBox>

        {/* Diğer */}
        <MDBox sx={cardSx} onClick={onGoOther}>
          <MDBox display="flex" alignItems="center" gap={1.25} minWidth={0}>
            <MDBox sx={iconBadgeSx}>
              <Icon sx={{ color: alpha(orange, 0.95) }}>receipt_long</Icon>
            </MDBox>
            <MDBox minWidth={0}>
              <MDTypography fontWeight="bold">Diğer Ödeme</MDTypography>
              <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                Ürün / ek hizmet • Açıklama + tutar gir
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDButton variant="outlined" color="warning" sx={{ borderRadius: '12px' }}>
            Seç
          </MDButton>
        </MDBox>
      </MDBox>

      <MDBox sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
        <MDButton variant="outlined" color="dark" onClick={onCancel} sx={{ borderRadius: '12px' }}>
          Vazgeç
        </MDButton>
      </MDBox>
    </>
  );
}
